import React, { forwardRef } from 'react'
import { motion } from 'framer-motion'
import { Box } from '@mui/material'

import ExpandMoreIcon from '../../../assets/icons/ExpandMore'

const ExpandMore = forwardRef((props, ref) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
    }}
    ref={ref}
    {...props}
  >
    <ExpandMoreIcon />
  </Box>
))

const AnimatedExpandMoreIcon = motion(ExpandMore)

export default AnimatedExpandMoreIcon
